/* "What extra sections do I get with Expanded?" is one of the questions asked most,
   and the comparison table answered it with the number 47. This puts a small text
   button beside that number and lists the 25 sections Expanded adds.

   Two things learned the hard way:
   - The affordance is a text button ("Which ones?"), matching the builder's own
     `learn` buttons. The store has never used a circled i.
   - The panel is appended to <body> and positioned fixed. Inside the table it was
     clipped by the wrapper's overflow-x and looked like nothing had happened.

   SOURCE OF TRUTH for the list: the printed tabs, via sections/biw-ck-sections.liquid,
   which is generated from the InDesign proofs. Rename a section there and update this
   list with it. The panel also links to the full index. */
(function () {
  'use strict';
  var ADDS = ['Family Information & History', 'Marriage & Partnerships', 'Children & Dependents', 'Pets', 'Faith, Spirituality, & Tradition', 'Military Service & Benefits', 'Memberships, Organizations, & Affiliations', 'Medical Summary', 'Medical Providers', 'Career & Education', 'Residence History', 'Ethical Will, Good to Know, & Legacy Messages', 'DNR, POLST & MOLST', 'Residences & Real Property', 'Vehicles, Boats & Recreational Property', 'Belongings, Valuables & Heirlooms', 'Firearms & Regulated Items', 'Storage Units & Safe Deposit Boxes', 'Privately Stored Property', 'Employer & Contractual Benefits', 'Debts Owed to You', 'Debts You Owe', 'Business Interests', 'Non-Medical Insurance', 'Tax Returns & Tax Information'];
  var pop = null, owner = null;

  function close() {
    if (!pop) return;
    pop.remove(); pop = null;
    if (owner) { owner.setAttribute('aria-expanded', 'false'); owner = null; }
    document.removeEventListener('click', outside, true);
    window.removeEventListener('resize', reflow);
    window.removeEventListener('scroll', reflow, true);
  }
  function outside(e) { if (pop && !pop.contains(e.target) && !e.target.closest('.v3-info__btn') && !e.target.closest('[data-v3-info-trigger]')) close(); }

  function reflow() { if (pop && owner) place(owner); }
  function place(btn) {
    // The sections chart is a tall image. Anchored to a button near the fold it
    // got whatever vertical room happened to be left, so it opened as a short
    // clipped box with a scrollbar and the chart running off the right edge.
    // Anything image-sized is centred in the viewport instead; only the small
    // text popovers stay anchored to their button.
    if (window.BIW_SECTIONS_IMG) {
      var cw = Math.min(760, window.innerWidth - 32);
      pop.style.width = cw + 'px';
      pop.style.left = Math.round((window.innerWidth - cw) / 2) + 'px';
      pop.style.top = '7vh';
      pop.style.bottom = 'auto';
      pop.style.maxHeight = '86vh';
      return;
    }
    var r = btn.getBoundingClientRect();
    var w = Math.min(360, window.innerWidth - 24);
    var left = Math.min(Math.max(12, r.left + r.width / 2 - w / 2), window.innerWidth - w - 12);
    var below = window.innerHeight - r.bottom;
    pop.style.width = w + 'px';
    pop.style.left = left + 'px';
    if (below > 320 || below > r.top) { pop.style.top = Math.round(r.bottom + 8) + 'px'; pop.style.bottom = 'auto'; pop.style.maxHeight = Math.round(below - 24) + 'px'; }
    else { pop.style.bottom = Math.round(window.innerHeight - r.top + 8) + 'px'; pop.style.top = 'auto'; pop.style.maxHeight = Math.round(r.top - 24) + 'px'; }
  }

  function open(btn) {
    close();
    owner = btn; btn.setAttribute('aria-expanded', 'true');
    pop = document.createElement('div');
    pop.className = 'v3-info__pop';
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-label', 'Sections Expanded adds');
    var img = window.BIW_SECTIONS_IMG || '';
    var body = img
      ? '<img class="v3-info__img" src="' + img + '" alt="All 47 CLEAR Kit sections, 1 to 22 in Essentials and 23 to 47 added by Expanded">'
      : '<ol class="v3-info__list" start="23">' + ADDS.map(function (t) { return '<li>' + t.replace(/&/g, '&amp;') + '</li>'; }).join('') + '</ol>';
    pop.innerHTML = '<button type="button" class="v3-info__x" aria-label="Close">&times;</button>' +
      '<p class="v3-info__h">Expanded adds sections 23 to 47</p>' + body; // V5: no link out - the shopper stays on the buy page
    document.body.appendChild(pop);
    place(btn);
    pop.querySelector('.v3-info__x').addEventListener('click', close);
    setTimeout(function () {
      document.addEventListener('click', outside, true);
      window.addEventListener('resize', reflow);
      window.addEventListener('scroll', reflow, true);
    }, 0);
  }

  function arm() {
    // Target a declared hook, not the cell's wording. The old version matched
    // the text "All 47" and stopped rendering the instant that copy changed.
    var cells = [].slice.call(document.querySelectorAll('[data-v3-info="sections"]'));
    if (!cells.length) cells = [].slice.call(document.querySelectorAll('td, .biwck-cell'))
      .filter(function (c) { return /^\s*All 47/i.test(c.textContent || ''); });
    // V4: any element marked data-v3-info-trigger opens the chart itself
    // (the "Help me choose" link beside the Kit option cards).
    [].slice.call(document.querySelectorAll('[data-v3-info-trigger]')).forEach(function (el) {
      if (el.dataset.v3Armed) return;
      el.dataset.v3Armed = '1';
      el.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (pop && owner === el) { close(); return; } open(el); });
    });
    cells.forEach(function (cell) {
      if (cell.dataset.v3Armed) return;
      cell.dataset.v3Armed = '1';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'v3-info__btn';
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = 'Which ones?';
      cell.appendChild(document.createTextNode(' '));
      cell.appendChild(btn);
      btn.addEventListener('click', function (e) { e.stopPropagation(); if (pop && owner === btn) { close(); return; } open(btn); });
    });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
  setTimeout(arm, 1200);
  // Dawn re-renders the option picker on a variant change; the trigger comes back unarmed.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios')) { setTimeout(arm, 400); setTimeout(arm, 1200); }
  }, true);
  // ?help=1 (the menu's "Help me choose") opens it on load
  if (/[?&]help=1/.test(location.search)) {
    var tries = 0, kick = function () { var el = document.querySelector('[data-v3-info-trigger]'); if (el) { el.scrollIntoView({ block: 'center' }); el.click(); } else if (tries++ < 20) setTimeout(kick, 200); };
    setTimeout(kick, 600);
  }
})();
